module.exports = __webpack_public_path__ + "static/media/layout-eight-1.502b25ba.jpg";